const formatter = {}
const topic_status = {
  'new': '待审核',
  'wait': '已通过',
  'assigned': '已通过',
  'reject': '未通过',
  'finished': '已通过'
}
formatter.topic_status_formatter = function (status) {
  if (topic_status[status]) {
    return topic_status[status]
  } else {
    return '未知'
  }
}

export default formatter
